import React, { Component } from 'react';
import SolutionGridContainer from "./grid/SolutionGridContainer";
import QuestionContainer from "./question/QuestionContainer";
import './Solution.scss';
import SummaryContainer from "./summary/SummaryContainer";

class Solution extends Component {

  constructor(props) {
    super(props);
    this.props.audioStop(); // Stop last question audio
  }

  render() {
    const {currentQuestion} = this.props;

    return (
      <section className="Solution-container">
        {currentQuestion != null ? null : <SummaryContainer/>}
        {currentQuestion != null ? <QuestionContainer/> : <SolutionGridContainer/>}
      </section>
    );
  }

}

export default Solution;
